var React = require('react');

function HSquare (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-48 336a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-80H160v80a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V144a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16v80h128v-80a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M352 368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-80H160v80a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V144a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16v80h128v-80a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16z","className":"fa-primary","key":2})]);
}

HSquare.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = HSquare;

HSquare.default = HSquare;
